import { attachLinkClickEvent } from "./attachLinkClickEvent";
import { attachSearchEvent } from "./attachSearchEvent";
import { createArticleList } from "./createArticleList";
import { getCurrentContext } from "./getCurrentContext";
import { initPagination } from "./initPagination";

export async function initBlog(g2Data: any)
{
    createArticleList(g2Data);

    initPagination(g2Data);

    attachSearchEvent(g2Data);

    attachLinkClickEvent(g2Data);
    
    getCurrentContext(); // This is to get the current page URL which can be used on blog article page return button
}
